// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".score-input--scoreInput--UKlM1r7d.score-input--disabled--2j3yHwq0 {\n  opacity: 0.35;\n}\n.score-input--scoreInput--UKlM1r7d input {\n  width: 50px;\n  margin-left: 5px;\n  padding: 5px 3px;\n  border: solid 1.5px #979797;\n  border-radius: 8px;\n  font-family: lato, arial, helvetica, sans-serif;\n  font-size: 16px;\n  text-align: right;\n}\n.score-input--scoreInput--UKlM1r7d input::-webkit-inner-spin-button {\n  margin-left: 5px;\n}\n.score-input--scoreInput--UKlM1r7d input::-webkit-outer-spin-button {\n  margin-left: 5px;\n}\n", ""]);
// Exports
exports.locals = {
	"scoreInput": "score-input--scoreInput--UKlM1r7d",
	"disabled": "score-input--disabled--2j3yHwq0"
};
module.exports = exports;
